// src/api/accounting/accountingApi.js
import { apiRequest } from "../apiConfig";

/**
 * ✅ Get revenue report with transactions
 * Endpoint: GET /admin/accounting/revenue
 */
export const getRevenueReport = () =>
  apiRequest("/admin/accounting/revenue", {
    method: "GET",
    timeoutMs: 120000, // ✅ 2 minutes (avoid AbortError)
  }).catch((err) => {
    console.error("Revenue Report Error:", err.message);
    // Return empty response on failure so UI doesn't break
    return {
      transactions: [],
      totalIncome: 0,
      totalExpense: 0,
      netRevenue: 0,
    };
  });

/**
 * ✅ Add a new transaction (income or expense)
 * Endpoint: POST /admin/accounting/transaction
 * 
 * @param {Object} payload
 * @param {string} payload.type - "income" or "expense"
 * @param {string} payload.mode - "Cash", "Online", "Bank", "UPI", "gpay", "phonepe"
 * @param {string} payload.description - Brief description
 * @param {number} payload.amount - Amount in decimal
 * @param {string} payload.currency - "INR" (default)
 * @param {string} payload.country - Country
 * @param {string} payload.state - State
 * @param {string} payload.city - City
 * @param {string} payload.date - YYYY-MM-DD format
 * @returns {Promise<Object>} Response with transaction ID
 */
export const addTransaction = (payload) =>
  apiRequest("/admin/accounting/transaction", {
    method: "POST",
    data: payload,
    timeoutMs: 120000,
  });

/**
 * ✅ Get transaction by ID
 * Endpoint: GET /admin/accounting/transaction/:id
 */
export const getTransaction = (id) =>
  apiRequest(`/admin/accounting/transaction/${id}`, {
    method: "GET",
    timeoutMs: 60000,
  });

/**
 * ✅ Update transaction
 * Endpoint: PUT /admin/accounting/transaction/:id
 */
export const updateTransaction = (id, payload) =>
  apiRequest(`/admin/accounting/transaction/${id}`, {
    method: "PUT",
    data: payload,
    timeoutMs: 60000,
  });

/**
 * ✅ Delete transaction
 * Endpoint: DELETE /admin/accounting/transaction/:id
 */
export const deleteTransaction = (id) =>
  apiRequest(`/admin/accounting/transaction/${id}`, {
    method: "DELETE",
    timeoutMs: 60000,
  });

/**
 * ✅ Get filtered transactions
 * Endpoint: GET /admin/accounting/transactions
 * 
 * @param {Object} filters
 * @param {string} filters.type - "income", "expense", or ""
 * @param {string} filters.country - Country filter
 * @param {string} filters.state - State filter
 * @param {string} filters.city - City filter
 * @param {string} filters.startDate - Start date (YYYY-MM-DD)
 * @param {string} filters.endDate - End date (YYYY-MM-DD)
 */
export const getFilteredTransactions = (filters = {}) =>
  apiRequest("/admin/accounting/transactions", {
    method: "GET",
    params: filters,
    timeoutMs: 120000,
  });

